import React from "react";
import { Tabs, Tab, Row, Col, FormLabel } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import Table from "../../../../core/Table";
import ComponentHeader from "../../../../core/ComponentHeader/ComponentHeader";

const UserDetail = props => {
  const user = props.user ? props.user : {};

  const roles = (
    <div>
      <div className="table-buttons-container">
        <div></div>
        <Table
          node={props.node}
          data={props.data}
          columns={props.columns}
          paginationOptions={props.paginationOptions}
          onTableChange={props.onTableChange}
          onRowClick={props.onRowClick}
          selectRow={props.selectRow}
          showTableHeader
          tableLabel={labels.userRoles}
          onDeleteRow={props.handleOnDelete}
          onCreateRow={props.handleAddNew}
          pageInfo={props.pageInfo}
          sortInfo={props.sortInfo}
        />
      </div>
    </div>
  );

  return (
    <div className="container">
      <ComponentHeader title={labels.user} id={user.partyId} showBackButton />{" "}
      <div className="bordered_bottom_rounded">
        <br></br>
        <Row>
          <Col sm="2">
            <FormLabel className="Label">{labels.name}</FormLabel>
          </Col>
          <Col sm="6">
            <FormLabel>
              {user.name} {user.lastName}
            </FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel className="Label">{labels.username}</FormLabel>
          </Col>
          <Col sm="6">
            <FormLabel>{user.username}</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel className="Label">{labels.email}</FormLabel>
          </Col>
          <Col sm="6">
            <FormLabel>{user.email}</FormLabel>
          </Col>
        </Row>

        <Tabs id="user_tabs" className="Tabs" mountOnEnter unmountOnExit>
          <Tab eventKey="userRoles" title={labels.userRoles} className="Tab">
            {roles}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default UserDetail;
